"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProducerEmailSenderDomain = void 0;
var ProducerEmailSenderDomain;
(function (ProducerEmailSenderDomain) {
    ProducerEmailSenderDomain["StageClip"] = "Stageclip";
    ProducerEmailSenderDomain["Institution"] = "Institution";
    ProducerEmailSenderDomain["HerffJones"] = "HerffJones";
})(ProducerEmailSenderDomain = exports.ProducerEmailSenderDomain || (exports.ProducerEmailSenderDomain = {}));
//# sourceMappingURL=producer-email-sender-domain.js.map